import { render, staticRenderFns } from "./treatments.vue?vue&type=template&id=039d16d0&scoped=true&"
import script from "./treatments.vue?vue&type=script&lang=js&"
export * from "./treatments.vue?vue&type=script&lang=js&"
import style0 from "./treatments.vue?vue&type=style&index=0&id=039d16d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039d16d0",
  null
  
)

export default component.exports